import { ErrorBoundary } from '@glow/common-components/error-boundary'
import i18next from 'i18next'
import React, { Suspense, useEffect } from 'react'
import { HelmetProvider } from 'react-helmet-async'
import { I18nextProvider } from 'react-i18next'
import { BrowserRouter, Route, Routes } from 'react-router'
import Loading from './common/components/Loading'
import { ThemeProvider } from './common/contexts/ThemeContext'
import { trackingPageLoaded } from './common/http/http'
import PageNotFound from './common/pages/PageNotFound'
import './i18n/i18n'
import { MetaTags } from './meta-tags'
import { bookingBaseUrl, oldBookingBaseUrl } from './norgespakke/BookingUrl'
import './styles/index.scss'
import './styles/typo.scss'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { removeLoadingSkeleton } from './utils/removeLoadingSkeleton'

const TrackDeliveryRoutes = React.lazy(() => import('./trackdelivery/TrackDeliveryRoutes'))
const TrackPickup = React.lazy(() => import('./trackpickup/pages/TrackPickup'))
const UpsalesTerms = React.lazy(() => import('./common/components/service-upsales/UpsalesTerms'))
const BookingRoutes = React.lazy(() => import('./norgespakke/pages/BookingRoutes'))

const queryClient = new QueryClient({})

function App() {
  useEffect(() => {
    removeLoadingSkeleton()
    // Only a load metric for the backend's command log, so a failed request is not worth an error report
    trackingPageLoaded().catch(() => {})
  }, [])
  return (
    <I18nextProvider i18n={i18next}>
      <Suspense fallback={<Loading role="alert" aria-live="polite" aria-label="Loading" />}>
        <ErrorBoundary
          isRunningTests={false}
          title={i18next.t('error.title')}
          buttonText={i18next.t('error.errorClickToReload')}
        >
          <ThemeProvider>
            <HelmetProvider>
              <a href="#main-content" className="skip-to-main-content-link">
                {i18next.t('skipToMainContent')}
              </a>
              <QueryClientProvider client={queryClient}>
                <BrowserRouter basename="/track">
                  <MetaTags />
                  <Routes>
                    <Route path={`${bookingBaseUrl}/*`} element={<BookingRoutes />} />
                    <Route path={`${oldBookingBaseUrl}/*`} element={<BookingRoutes />} />
                    <Route path="pickup/:trackingId" element={<TrackPickup />} />
                    <Route path=":trackingId/*" element={<TrackDeliveryRoutes />} />
                    <Route path="upsales-terms" element={<UpsalesTerms />} />
                    <Route path="*" element={<PageNotFound />} />
                  </Routes>
                </BrowserRouter>
                <ReactQueryDevtools initialIsOpen={false} />
              </QueryClientProvider>
            </HelmetProvider>
          </ThemeProvider>
        </ErrorBoundary>
      </Suspense>
    </I18nextProvider>
  )
}

export default App
